import { Link } from "react-router-dom";
import { Facebook, Instagram, Mail, Phone } from "lucide-react";

export default function Footer({ content, categories }) {
  const phone = content?.phone || "(380) 800-6365";
  const email = content?.email || "info@crystallogistics.services";
  return (
    <footer className="bg-[#080e20] border-t border-[#1E293B]" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10">
          <div className="col-span-2 md:col-span-1">
            <span className="bg-white rounded-md p-1.5 inline-flex mb-4">
              <img src="/logo.png" alt="Crystal Logistics Services" className="h-10 w-auto" />
            </span>
            <p className="text-sm text-slate-400 leading-relaxed">
              Expert truck permit consulting, licensing and compliance for carriers in all 50 states.
            </p>
            <div className="flex gap-3 mt-5">
              <a href="https://www.facebook.com/crystallogistics.servicess/" target="_blank" rel="noopener noreferrer"
                data-testid="footer-facebook" className="w-9 h-9 rounded-md bg-[#131C38] border border-[#1E293B] flex items-center justify-center text-slate-400 hover:text-[#F97316] hover:border-[#F97316] transition-colors">
                <Facebook className="w-4 h-4" />
              </a>
              <a href="https://www.instagram.com/crystallogistics.services/" target="_blank" rel="noopener noreferrer"
                data-testid="footer-instagram" className="w-9 h-9 rounded-md bg-[#131C38] border border-[#1E293B] flex items-center justify-center text-slate-400 hover:text-[#F97316] hover:border-[#F97316] transition-colors">
                <Instagram className="w-4 h-4" />
              </a>
            </div>
          </div>
          <div>
            <h4 className="font-display text-lg font-semibold text-white mb-4 tracking-wide">MENU</h4>
            <ul className="space-y-2.5 text-sm">
              {[["Services", "/services"], ["Trucking Insights", "/blog"], ["About Us", "/about"], ["Contact Us", "/contact"]].map(([l, to]) => (
                <li key={to}><Link to={to} data-testid={`footer-link-${l.toLowerCase().replace(/\s+/g, "-")}`}
                  className="text-slate-400 hover:text-[#F97316] transition-colors">{l}</Link></li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="font-display text-lg font-semibold text-white mb-4 tracking-wide">SERVICES</h4>
            <ul className="space-y-2.5 text-sm">
              {(categories || []).slice(0, 5).map((c) => (
                <li key={c.slug}>
                  <Link to={`/services#${c.slug}`} data-testid={`footer-cat-${c.slug}`}
                    className="text-slate-400 hover:text-[#F97316] transition-colors">{c.name}</Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="font-display text-lg font-semibold text-white mb-4 tracking-wide">CONTACT</h4>
            <ul className="space-y-3 text-sm">
              <li>
                <a href={`tel:${phone.replace(/[^+\d]/g, "")}`} data-testid="footer-phone"
                  className="flex items-center gap-2 text-slate-400 hover:text-[#F97316] transition-colors">
                  <Phone className="w-4 h-4 text-[#F97316]" /> {phone}
                </a>
              </li>
              <li>
                <a href={`mailto:${email}`} data-testid="footer-email"
                  className="flex items-center gap-2 text-slate-400 hover:text-[#F97316] transition-colors break-all">
                  <Mail className="w-4 h-4 text-[#F97316] shrink-0" /> {email}
                </a>
              </li>
              <li className="text-slate-500 text-xs pt-2">{content?.address || "Serving carriers nationwide, USA"}</li>
            </ul>
          </div>
        </div>
        <div className="border-t border-[#1E293B] mt-12 pt-6 flex flex-col sm:flex-row justify-between gap-2 text-xs text-slate-500">
          <span data-testid="footer-copyright">Copyright © {new Date().getFullYear()} Crystal Logistics Services. All rights reserved.</span>
          <span>FMCSA / DOT compliance consulting — not a government agency.</span>
        </div>
      </div>
    </footer>
  );
}
